const TRACK_SELECTOR = '[data-steinara-reviews-track]';
const CARD_SELECTOR = '.steinara-review-card';
const initializedTracks = new WeakSet();

function getCards(track) {
  return Array.from(track.children).filter((child) => child.matches(CARD_SELECTOR));
}

function getScrollBehavior() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
}

function getScrollStep(track) {
  const card = getCards(track)[0];
  if (!card) return 0;

  const styles = window.getComputedStyle(track);
  const gap = parseFloat(styles.columnGap || styles.gap) || 0;

  return card.getBoundingClientRect().width + gap;
}

function updateControls(track, previous, next) {
  const maxScrollLeft = Math.max(0, track.scrollWidth - track.clientWidth);
  const hasOverflow = maxScrollLeft > 1;

  for (const control of [previous, next]) {
    if (control) control.hidden = !hasOverflow;
  }

  if (!hasOverflow) return;

  if (previous) previous.disabled = track.scrollLeft <= 1;
  if (next) next.disabled = track.scrollLeft >= maxScrollLeft - 1;
}

function initializeTrack(track) {
  if (initializedTracks.has(track)) return;

  const section = track.closest('.steinara-reviews-section');
  const previous = section?.querySelector('[data-reviews-previous]');
  const next = section?.querySelector('[data-reviews-next]');

  if (!section) return;

  initializedTracks.add(track);

  const scroll = (direction) => {
    const step = getScrollStep(track);
    if (!step) return;

    track.scrollBy({
      behavior: getScrollBehavior(),
      left: direction * step,
    });
  };

  previous?.addEventListener('click', () => scroll(-1));
  next?.addEventListener('click', () => scroll(1));

  track.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      scroll(-1);
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      scroll(1);
    } else if (event.key === 'Home') {
      event.preventDefault();
      track.scrollTo({ behavior: getScrollBehavior(), left: 0 });
    } else if (event.key === 'End') {
      event.preventDefault();
      track.scrollTo({ behavior: getScrollBehavior(), left: track.scrollWidth });
    }
  });

  let frameRequested = false;
  track.addEventListener(
    'scroll',
    () => {
      if (frameRequested) return;

      frameRequested = true;
      window.requestAnimationFrame(() => {
        frameRequested = false;
        updateControls(track, previous, next);
      });
    },
    { passive: true }
  );

  if ('ResizeObserver' in window) {
    new ResizeObserver(() => updateControls(track, previous, next)).observe(track);
  } else {
    window.addEventListener('resize', () => updateControls(track, previous, next), { passive: true });
  }

  updateControls(track, previous, next);
}

function initialize(root = document) {
  if (root.matches?.(TRACK_SELECTOR)) initializeTrack(root);
  root.querySelectorAll?.(TRACK_SELECTOR).forEach(initializeTrack);
}

initialize();
document.addEventListener('shopify:section:load', (event) => initialize(event.target));
